export default "__VITE_ASSET__DLrMoAsW__"